<div class="kgr-alert kgr-alert--error kgr-screenMargin">
  <h2 class="kgr-headline kgr-headline--h4 kgr-headline--text kgr-headline--firstInText" i18n>Leider ist folgender Fehler aufgetreten:</h2>
  <h2 class="kgr-headline kgr-headline--h3 kgr-headline--text">{{ statusToHeadlineMapping[status] }}</h2>

  @if (wasOffline) {
    <div>
      @if (isOffline$ | async) {
        <ng-container i18n> Offline - es besteht keine Verbindung mit dem Internet. </ng-container>
      }
      @if (isOnline$ | async) {
        <p class="kgr-paragraph" i18n>Das Gerät ist jetzt wieder mit dem Internet verbunden.</p>
        <button class="kgr-button kgr-button--accent" (click)="refresh()" i18n>Daten Aktualisieren</button>
      }
    </div>
  }
</div>
